import type { Book } from "../components/BookExtracts/types";
import { stripHtml } from "../utils/stripHtml";

const API_URL =
  process.env.REACT_APP_API_URL ?? "http://localhost:7072/api/BookExtracts";

interface BookExtractsResponse {
  count: number;
  query: string;
  results: Book[];
}

// Sends the search query to the Azure Function (POST). An empty query
// returns all extracts by default. Accepts an AbortSignal so the caller
// can cancel a request that is no longer needed.
export async function fetchBookExtracts(
  query: string,
  signal?: AbortSignal,
): Promise<Book[]> {
  const response = await fetch(API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ query }),
    signal,
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  const data: BookExtractsResponse = await response.json();

  // Stripping html tags from the authorBiography 
  return data.results.map((book) => ({
    ...book,
    authorBiography: stripHtml(book.authorBiography),
  }));
}
